module.exports = __webpack_public_path__ + "static/media/get_more_img_1.7bcb9e7e.svg";